// Webpack will inject inView as a plugin
import { gpCommon } from '../app';

gpCommon.directive('gpLazyLoadImage', lazyLoad)

let gpLazyImageCount = 0;
function lazyLoad() {
    return {
        restrict: 'A',
        link: function (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {

            let id = `img${gpLazyImageCount}`
            gpLazyImageCount++;
            element.attr("lazy-img-id", id)
            inView(`[lazy-img-id="${id}"]`)
                .on('enter', loadImg);

            function loadImg() {
                if (!element.attr("src")) {
                    element.attr("src", element.attr("lazy-src") as string);
                }
            }

            // Once the image has loaded, follow later URL changes (e.g. a
            // cache-busted thumbnail after the plan is saved). Before the
            // first in-view load, the enter handler reads the latest value.
            attrs.$observe('lazySrc', (value?: string) => {
                if (value && element.attr("src") && element.attr("src") !== value) {
                    element.attr("src", value);
                }
            });

        }
    }
}

